import*as t from"react";import{defaultComponents as o}from"./defaultComponents.js";const e=t.createContext({components:Object.assign({},o)}),n=()=>t.useContext(e);export{e as CustomComponentsContext,n as useCustomComponents};
